export default function DateDiapasonChange(begin, end) {
    return {
        type: 'HISTORY_ACTION',
        payload: {
            begin, end, history: []
        }
    }
};



/** WEBPACK FOOTER **
 ** ./src/modules/food/actions/history/DateDiapasonChange.js
 **/